import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Preventing Insurance Fraud' },
	{
		name: 'description',
		content: 'Preventing and awareness of insurance fraud.',
	},
]

export default function Component() {
	return (
		<>
			<br />
			<br />
			<h1 className="py-3 text-4xl font-black">
				Preventing and awareness of insurance fraud
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The natural human being has a tendency to try to take advantage of
				opportunities to get ahead financially. Sometimes this means that when
				presented with the option of taking advantage of an insurance company by
				increasing the amount received in a claim settlement
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Insurance fraud has many forms:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				* Paying too low a premium than what is fair by lying or cheating when
				obtaining or while owning a policy.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				* Purposely causing a claim payout to be larger than it needs to be.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				All of these are forms of dishonesty and theft, and have some strong
				consequences. You and I bear the burden of paying much higher insurance
				premiums because the high cost of insurance fraud is spread by insurers
				with all policyholders.
			</p>
		</>
	)
}
